"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhoneFieldComponent = function PhoneFieldComponent(props) {
  var variant = props.variant,
      required = props.required,
      name = props.name;

  if (!variant) {
    variant = "mobile";
  }

  if (name === undefined) {
    name = "";
  } else {
    name = "_" + name;
  }

  if (required === undefined) {
    required = false;
  }

  var isValid = function isValid(tel) {
    var re = /^[0-9]{10,15}$/;
    return (tel || !required) && (re.test(tel) || !required && (tel === undefined || (tel === null || tel === void 0 ? void 0 : tel.length) === 0)) ? undefined : "Enter a valid " + variant + " number";
  };

  var stripSpaces = function stripSpaces(value) {
    return value && value.replace(/ /g, "");
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: variant + name,
    validate: isValid,
    label: variant.charAt(0).toUpperCase() + variant.slice(1) + " Number",
    autoComplete: "tel-national",
    required: required,
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    parse: stripSpaces,
    fullWidth: true,
    inputProps: {
      maxLength: 15
    }
  });
};

var _default = PhoneFieldComponent;
exports.default = _default;